/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

// ─── Rider Operations Module — Entity Types ───────────────────────────────────
// These types belong to the Rider Operations module only.
// Platform-level types (User, Organization, etc.) remain in src/domain/entities.ts

export interface RiderHistoryEntry {
  branchId: string;
  startDate: number;
  endDate: number | null;
  daysSpent: number | null;
}

export interface Rider {
  id: string;
  fileNumber: number;
  name: string;
  email?: string;
  phone?: string;
  mobile: string;
  branchId: string;
  contract: string;
  isActive: boolean;
  createdAt: number;
  history?: RiderHistoryEntry[];
  orgId?: string;
  brandId?: string; // references Brand.id from global registry
}

export enum RequestType {
  NEW_RIDER = 'NEW_RIDER',
  TRANSFER = 'TRANSFER'
}

export enum RequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export interface WorkflowRequest {
  id: string;
  type: RequestType;
  status: RequestStatus;
  requesterId: string;
  requesterName: string;
  branchId: string;
  riderId?: string; // For transfer
  riderData?: Partial<Rider>; // For new rider
  adminNote?: string;
  createdAt: number;
  orgId?: string;
}

export interface RiderSettings {
  fileNoStart: number;
  fileNoPadding: number;
  contracts: string[];
  cardHeader: string;
  orgId?: string;
}
